<template>
  <slot />
</template>

<script setup>
import { onErrorCaptured } from "vue";
const props = defineProps({
  owners: { type: Array, required: true }
});
function hasOwners(cause) {
  if (!cause) return false;
  if (!cause.owners) return false;
  return true;
}
onErrorCaptured((error, instance) => {
  const componentName = instance?.$options?.__name || "none";
  const owners = hasOwners(error.cause) ? error.cause.owners : props.owners;
  try {
    if (error instanceof Error)
      error.cause = error.cause ? { ...error.cause, owners, componentName } : { owners, componentName };
  } catch {
  }
  return true;
});
</script>
